import { cn } from "@/lib/utils";
import type { MatchFactor } from "@/types";

export function MatchFactorBar({ factor }: { factor: MatchFactor }) {
  const max = Math.round(factor.weight * 100);
  const pct = max > 0 ? (factor.contribution / max) * 100 : 0;
  const color =
    factor.status === "ok"
      ? "bg-success"
      : factor.status === "warn"
        ? "bg-warning"
        : "bg-destructive";
  return (
    <div>
      <div className="flex items-center justify-between text-xs mb-1">
        <span className="text-foreground font-medium">{factor.label}</span>
        <span className="text-muted-foreground tabular-nums">
          {factor.contribution} / {max}
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={cn("h-full rounded-full transition-all", color)}
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-[11px] text-muted-foreground mt-1">{factor.detail}</p>
    </div>
  );
}
